import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            newPassword:'',
            repeatPassword:'',
            firstName: '',
            lastName: '',
            username: ''
        }
    },
    methods: {
        checkNull: checkNull,
        resetPassword: resetPassword,
        load: load,
    },
    beforeMount() {
        if(session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/maps');
            return;
        }
        this.load();

    }
}

function load() {
    let _self = this;
    AdminApiService.getDispatcherAdminMe()
        .then((response) => {
            _self.username = response.data.username;
            _self.firstName = this.checkNull(response.data.firstName);
            _self.lastName = this.checkNull(response.data.lastName);

        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}

function resetPassword() {
    if(this.newPassword.trim() === ''){
        swal('Greška', 'Nova lozinka ne sme biti prazna', 'error');
        return;
    }

    if(this.newPassword !== this.repeatPassword){
        swal('Greška', 'Ponovite istu lozinku', 'error');
        return;
    }

    if(this.username.length === 0){
        swal('Greška', 'Došlo je do greške, molimo Vas pokušajte kasnije', 'error')
        return;
    }

    let model = {
        firstName: this.firstName,
        lastName: this.lastName,
        username: this.username,
        password: this.newPassword
    }

    AdminApiService.updateDispatchersAndAdmin(model)
        .then((response) => {
            swal('Uspešno', 'Uspešno promenjena lozinka', 'success')
            this.$sessionService.destroyUser();
            this.$router.push('/login');
        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}

function checkNull(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/components/Account/ResetPassword.js